import React from "react";
import { useNavigate } from "react-router-dom";
import css from "./failedLessonScreen.module.css";
import { useTranslation } from "react-i18next";
import Header from "../standartComponents/header";

const FailedLessonScreen = ({ lesson, onRepeat, authUser }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  // Extract scores or default to the ones from the template
  const rawQuizScore = lesson?.quizScore !== undefined ? lesson.quizScore : 50; 
  const rawSpeakingScore = lesson?.speakingScore !== undefined ? lesson.speakingScore : 80;

  // Assume passing is >= 70%
  const passThreshold = 70;
  
  // Convert percentage to 1-10 scale for the UI, or use raw if already in 1-10
  const quizScoreDisplay = rawQuizScore > 10 ? Math.round(rawQuizScore / 10) : rawQuizScore;
  const speakingScoreDisplay = rawSpeakingScore > 10 ? Math.round(rawSpeakingScore / 10) : rawSpeakingScore;

  const quizPassed = rawQuizScore >= passThreshold || quizScoreDisplay >= 7;
  const speakingPassed = rawSpeakingScore >= passThreshold || speakingScoreDisplay >= 7;

  const handleRepeatLesson = () => {
    if (onRepeat) {
      onRepeat();
    } else {
      window.location.reload();
    }
  };

  return (
    <div className={css.trialPage}>
      {/* HEADER */}
      <Header authUser={authUser} />

      <div className={css.wrap}>
        {/* HERO */}
        <div className={css.hero}>
          <div className={css.heroIcon}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 8v4"/><path d="M12 16h.01"/></svg>
          </div>
          <h1>{t('lessonFailed.title', 'Майже вийшло!')}</h1>
          <p>{t('lessonFailed.subtitle', 'Щоб зарахувати урок, потрібно виконати дві умови. Подивіться, чого не вистачає.')}</p>
        </div>

        {/* CONDITIONS */}
        <div className={css.conds}>
          {/* Quiz Condition */}
          <div className={`${css.cond} ${quizPassed ? css.condPass : css.condFail}`}>
            <div className={css.condTop}>
              <div className={css.condLabel}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><path d="M12 17h.01"/></svg>
                Перевірка знань
              </div>
              <div className={css.condBadge}>{quizPassed ? 'Пройдено ✓' : 'Не пройдено'}</div>
            </div>
            <div className={css.condScore}>
              <span className={css.condVal}>{quizScoreDisplay}</span>
              <span className={css.condOf}>з 10</span>
            </div>
            <div className={css.condNeed}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><path d="m9 11 3 3L22 4"/></svg>
              Потрібно мінімум 7 правильних
            </div>
            <div className={css.condBar}>
              <div className={css.condBarFill} style={{ width: `${quizScoreDisplay * 10}%` }}></div>
            </div>
          </div>

          {/* Speaking Condition */}
          <div className={`${css.cond} ${speakingPassed ? css.condPass : css.condFail}`}>
            <div className={css.condTop}>
              <div className={css.condLabel}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z"/><path d="M19 10v2a7 7 0 0 1-14 0v-2"/></svg>
                Розмова з AI
              </div>
              <div className={css.condBadge}>{speakingPassed ? 'Пройдено ✓' : 'Не пройдено'}</div>
            </div>
            <div className={css.condScore}>
              <span className={css.condVal}>{speakingScoreDisplay}</span>
              <span className={css.condOf}>з 10</span>
            </div>
            <div className={css.condNeed}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><path d="m9 11 3 3L22 4"/></svg>
              Потрібно 70% правильних реплік
            </div>
            <div className={css.condBar}>
              <div className={css.condBarFill} style={{ width: `${speakingScoreDisplay * 10}%` }}></div>
            </div>
          </div>
        </div>

        {/* ACTIONS */}
        <div className={css.actions}>
          <div className={css.actRow}>
            <button className={`${css.actBtn} ${css.actQuiz}`} onClick={handleRepeatLesson}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><path d="M12 17h.01"/></svg>
              Повторити Quiz
            </button>
            <button className={`${css.actBtn} ${css.actSpeak}`} onClick={handleRepeatLesson}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z"/><path d="M19 10v2a7 7 0 0 1-14 0v-2"/></svg>
              Повторити Speaking
            </button>
          </div>
          <button className={`${css.actBtn} ${css.actBack}`} onClick={() => navigate('/roadMap')}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M19 12H5"/><path d="m12 19-7-7 7-7"/></svg>
            Повернутися до курсу
          </button>
        </div>

        {/* ENCOURAGE */}
        <div className={css.encourage}>
          <div className={css.encIcon}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m12 3-1.9 5.8a2 2 0 0 1-1.3 1.3L3 12l5.8 1.9a2 2 0 0 1 1.3 1.3L12 21l1.9-5.8a2 2 0 0 1 1.3-1.3L21 12l-5.8-1.9a2 2 0 0 1-1.3-1.3L12 3Z"/></svg>
          </div>
          <div className={css.encText}>
            <strong>Це нормально!</strong> Повторення — найкращий спосіб запам'ятати. Пройдіть те, чого не вистачає, і урок буде зараховано.
          </div>
        </div>

      </div>
    </div>
  );
};

export default FailedLessonScreen;
